import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FrontEndColumn } from '@app/shared/interfaces/front-end-column';
import { FilterType } from '@app/shared/interfaces/front-end-column';
import { FilterOperator } from '@product/shared/models/Enums.enum';
import { FilterOperatorModel } from '@product/shared/models/filters.interface';
import { FilterObject } from '@product/shared/models/ListPayload';
import { CommonService } from '@product/shared/services/common.service';
import { FilterLogicService } from '@product/shared/services/filter-logic.service';

@Component({
  selector: 'app-filter-base',
  templateUrl: './filter-base.component.html',
  styleUrls: ['./filter-base.component.less'],
})
export class FilterBaseComponent implements OnInit {
  private _column: FrontEndColumn;
  //new var
  @Input() filterId: string;
  @Input() valueInput: any;

  @Output() FilterValueChanged = new EventEmitter();
  @Input() set column(value: FrontEndColumn) {
    if (value != null) {
      this._column = value;
      this.fieldFilterOprs = this.filterService.getFilterOperators(value);
      this.selectedFilterOprCode = this.fieldFilterOprs[0].code;
      this.selectedFilterOpr = this.fieldFilterOprs.find(
        (x) => x.code === this.selectedFilterOprCode
      )!;
      this.getFilterType();//load filter type
    }
  }
  get column() {
    return this._column;
  }
  @Input() withLabels = true;
  @Input() set inputFilters(filters: { [ket: string]: FilterObject }) {
    if (filters == null || Object.keys(filters).length == 0) {
      return;
    }
    const columnName = this.column.filterCode ?? this.column.name;
    const filterObject = filters[columnName];
    if (filterObject == null) {
      return;
    }
    this.selectedFilterOpr = this.fieldFilterOprs.find(
      (x) => x.operator == filterObject.Operator
    )!;
    if (
      this.column.filterType === FilterType.Select &&
      this.column.name != 'type'
    ) {
      this.value = +filterObject.Value;
    } else {
      this.value = filterObject.Value;
    }
  }
  fieldFilterOprs: FilterOperatorModel[] = [];
  value: any;
  selectedFilterOprCode: any;
  selectedFilterOpr: FilterOperatorModel;
  FilterTypes = FilterType;
  constructor(
    private filterService: FilterLogicService,
    private commonService: CommonService,
  ) {}
  ngOnInit() {
    
  }

  selectFilterOperator(filterCode: string) {
    this.selectedFilterOpr = this.fieldFilterOprs.find(
      (x) => x.code === filterCode
    )!;
    console.log('selectedFilterOpr',  this.selectedFilterOpr.label);
    
    this.saveFilterType(this.selectedFilterOpr.label);//save filter type
    this.selectedFilterOpr.operator == FilterOperator.isEmpty;
    this.onFilterValueChange(this.value);
  }
  onFilterValueChange(value: any) {

    
    if (value instanceof FocusEvent) {
      value = (value?.target as any).value;
    }
    if (typeof value == 'string') {
      value = value.trim();
    }

    this.value = value;
    //New

//   this.FilterValueChanged.emit({
//     [this.column.name]: {
//         AdditionalInfo: this.selectedFilterOpr.additionalInfo ?? '{}',
//         Operator: this.selectedFilterOpr.operator,
//         Type: this.column.filterType!,
//         Value: this.value?.toString()
//     }
// });


    if (this.column.name === 'completionSetId') {
      const baseInfo = this.selectedFilterOpr.additionalInfo;
      const options =
        this.commonService.dropDownMetaData[
          this.column.filterCode ?? this.column.name
        ];
      const additionalInfo = options.find((x) => x.Code == value)?.Additional;
      
        
      let infoTobeAdded = null;
      if (additionalInfo != null && additionalInfo.completionGroup != null) {
        infoTobeAdded = {
          completionGroup: true,
        };
      }
      if (infoTobeAdded != null) {
        this.selectedFilterOpr.additionalInfo = JSON.stringify({
          ...JSON.parse(baseInfo ?? '{}'),
          ...infoTobeAdded,
        });
      }
    }
    this.filterService.handleFilterObject(
      this.selectedFilterOpr,
      this.value?.toString(),
      this.column
    );
  //  this.handleFilter();
    // subscribe to this emitter if you don't want to subscribe to
    // the global filter change emitter in the filters service
    this.FilterValueChanged.emit({
      AdditionalInfo: this.selectedFilterOpr.additionalInfo ?? '{}',
      Operator: this.selectedFilterOpr.operator,
      Type: this.column.filterType!,
      Value: this.value?.toString(),
    });

    
  }




//method Save State Filter Type

saveFilterType(label: string): void {
  if (!this.filterId) return;
  localStorage.setItem(`filterType_${this.filterId}`, label);
}

  getFilterType(): void {
    if (!this.filterId) return;
    const savedFilterType = localStorage.getItem(`filterType_${this.filterId}`);
    if (savedFilterType) {
        const filterIndex = this.fieldFilterOprs.findIndex(op => op.label === savedFilterType);
        if (filterIndex !== -1) {
            this.selectedFilterOprCode = this.fieldFilterOprs[filterIndex].code;
            this.selectedFilterOpr = this.fieldFilterOprs[filterIndex];
        }
    } else {
        this.selectedFilterOprCode = this.fieldFilterOprs[0].code;
        this.selectedFilterOpr = this.fieldFilterOprs[0];
    }
}
//   async handleFilter() {
//     console.log('handleFilter start');
    
//     try {
//   this.filterService.handleFilterObject(
//       this.selectedFilterOpr,
//       this.value?.toString(),
//       this.column
//     );
//     console.log('handleFilter complet');
//     } catch (error) {
//       console.log('error');
      
//       console.error('error  handling filter:', error);
//     }
// }

}
